<template>
	<main-tabs :links="links" target="_blank">
		<router-view></router-view>
	</main-tabs>
</template>

<script>
	export default {
		data() {
			return {
				links: [{
					to: {
						path: '/jscx-relation/domain-direction'
					},
					label: 'Domain Direction'
				}, {
					to: {
						path: '/jscx-relation/term-direction'
					},
					label: 'Term Direction'
				}]
			}
		}
	}
</script>
